import React from "react";
import PropTypes from "prop-types";

import LoadingSpinner from "../../../../shared_components/loading_spinner";

class Overview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      parameterRows: true
    };
  }

  render () {
    const {
      parameters,
      countries,
      groupedStandards,
      regulations,
      noParameters,
      regulationStandardClick,
      purpose,
      panelOpen,
      isLoading
    } = this.props;
    if (noParameters) { return <h4>Begin by choosing some parameters</h4>; }
    // Perf: the overview is a parameters × countries matrix. Selecting a parameter re-fetches a
    // correctly-filtered (small) result, but `make_main_view` renders the overview during that fetch
    // (showComponentWhenLoading.overview) — so on the FIRST selection it rendered the pre-fetch data
    // (ALL ~1,278 params × ~40 countries ≈ 116k DOM nodes) before the fetch narrowed it, blocking the
    // main thread ~2s (the "first selection takes ~10s" report). Two guards fix that without changing
    // the settled result (both take precedence over the data/"no data" branch below):
    //   1. While the picker overlay is open the matrix is off-screen — show a prompt instead of
    //      building it, so every parameter tick stays instant.
    if (panelOpen) { return <h4>Close the parameter panel to view the results table.</h4>; }
    //   2. While a re-fetch is in flight the current data is stale/about-to-be-replaced — show the
    //      spinner rather than rendering it, so the huge stale matrix is never built.
    if (isLoading) { return <LoadingSpinner show={true} />; }
    if (!groupedStandards) { return <h4>No data returned by current filter combination</h4>; }

    // const layout = "CountryRows";
    // const layout = "ParameterRows";
    let header, rows, columnTitle, rowTitle;

    if (this.state.parameterRows) {
      header = countries.map(e => <th key={e.id}>{e.name}</th>);

      rows = parameters.map((parameter) => {
        const countryStandards = countries.map((country) => {
          let maxValue = (groupedStandards[country.id][parameter.id] || {}).maxValue;
          let value = maxValue;

          if (typeof maxValue === "undefined") { value = "—"; }

          return (<td onClick={regulationStandardClick(country, parameter, purpose)} key={country.id}><div className="standard-value">{value}</div></td>);
        });

        return (<tr key={parameter.id}>
          <td key="parameter">
            <div className="parameter-and-unit">
              <span className="parameter">{parameter.name}</span>
              <span className="unit">{parameter.unit}</span>
            </div>
          </td>

          {countryStandards}
        </tr>);
      });

      const regulationLinks = countries.map((country) => {
        const regsForCountry = regulations.filter((reg) => reg.countryId === country.id);
        const count = regsForCountry.length;
        const regulationIds = regsForCountry.map(e => e.id).join(",");
        const href = `/data-hub/regulations/by-regulation/?regulation_ids=${regulationIds}`;
        return <td key={country.id}><a target="_blank" href={href}>Relevant regulations ({count})</a></td>;
      });
      rows.push(
        <tr key="regulation-links" className="regulation-links">
          <td key="blank"></td>
          {regulationLinks}
        </tr>);
      columnTitle = "Country";
      rowTitle = "Parameter";
    } else {
      header = parameters.map(e => <th key={e.id}>
            <div className="parameter-and-unit">
              <span className="parameter">{e.name}</span>
              <br />
              <span className="unit">({e.unit})</span>
            </div>
          </th>);

      const regulationLinks = countries.reduce((a, country) => {
        const regsForCountry = regulations.filter((reg) => reg.countryId === country.id);
        const count = regsForCountry.length;
        const regulationIds = regsForCountry.map(e => e.id).join(",");
        const href = `/data-hub/regulations/by-regulation/?regulation_ids=${regulationIds}`;
        a[country.id] = <td className="regulation-link" key={`link-${country.id}`}><a target="_blank" href={href}>Relevant regulations ({count})</a></td>;

        return a;
      }, {});

      rows = countries.map((country) => {
        const parameterStandards = parameters.map((parameter) => {
          const maxValue = (groupedStandards[country.id][parameter.id] || {}).maxValue;
          let onClick;
          let value;
          let className;
          if (typeof maxValue === "undefined") {
            onClick = () => {};
            value = "—";
            className = "no-values";
          } else {
            onClick = regulationStandardClick(country, parameter, purpose);
            value = maxValue;
            className = "";
          }

          return (<td onClick={onClick} key={parameter.id} className={className}><div className="standard-value">{value}</div></td>);
        });

        parameterStandards.push(regulationLinks[country.id]);

        return (<tr key={country.id}>
          <td key={country.id}>{country.name}</td>

          {parameterStandards}
        </tr>);
      });
      columnTitle = "Parameter";
      rowTitle = "Country";
    }

    const transpose = () => {
      this.setState({ parameterRows: !this.state.parameterRows });
    };

    return (
      <div className="overview">
        <p>Values shown here are the strictest requirements. Click each cell to view specific numerical standards for that parameter.</p>
        <table>
          <thead>
            <tr>
              <th onClick={transpose} className="transpose-button">Transpose table</th>
              <th className="no-bg" colSpan={9999}>{columnTitle}</th>
            </tr>
            <tr>
              <th className="no-bg">{rowTitle}</th>

              {header}
            </tr>
          </thead>

          <tbody>
           {rows}
          </tbody>
        </table>
      </div>
    );
  }
}

Overview.propTypes = {
  parameters: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  groupedStandards: PropTypes.object,
  regulations: PropTypes.array.isRequired,
  noParameters: PropTypes.bool.isRequired,
  regulationStandardClick: PropTypes.func.isRequired,
  purpose: PropTypes.object.isRequired,
  panelOpen: PropTypes.bool,
  isLoading: PropTypes.bool
};

export default Overview;
